import AntIcon from "@/components/icons/AntIcon";
import { StrikeDiagonal } from "@/components/StrikeDiagonal";
import { cssVariables } from "@/utils/utils";
import { Button, Flex, Popover } from "antd";
import { useTranslation } from "react-i18next";
import { useToggleAgentCommissionsOutput } from "../../../../common/api/queries";
import { Permission } from "../../../../common/security/enums";
import { UUID } from "../../../../typings/global";
import ComponentWithPermission from "../../../auth/components/ComponentWithPermission";

type Props = {
  data: {
    id: UUID;
    paidInBatch?: boolean;
    optimisticLockVersion: number;
  };
  noAction?: boolean;
};

export const PaidInBatchField = ({ data, noAction }: Props) => {
  const { t } = useTranslation();

  const toggleAgentCommissionsOutput = useToggleAgentCommissionsOutput();

  if (data.paidInBatch) {
    return (
      <Popover
        content={
          <Flex vertical align="center">
            <strong>{t("commissions.batch.helpers.paid")}</strong>

            {!noAction && (
              <ComponentWithPermission permissions={[Permission.COMMISSIONS_MANAGE]}>
                <Button
                  className="margin-top-tiny"
                  size="small"
                  variant="outlined"
                  color="red"
                  onClick={() =>
                    toggleAgentCommissionsOutput.mutate({
                      entries: [{ id: data.id, optimisticLockVersion: data.optimisticLockVersion }],
                    })
                  }
                >
                  {t("commissions.batch.helpers.markAsUnPaid")}
                </Button>
              </ComponentWithPermission>
            )}
          </Flex>
        }
      >
        <div>
          <AntIcon type="euro-circle" color="green" />
        </div>
      </Popover>
    );
  }

  return (
    <Popover
      content={
        <Flex vertical align="center">
          <strong>{t("commissions.batch.helpers.notPaid")}</strong>

          {!noAction && (
            <ComponentWithPermission permissions={[Permission.COMMISSIONS_MANAGE]}>
              <Button
                className="margin-top-tiny"
                size="small"
                variant="outlined"
                color="green"
                onClick={() =>
                  toggleAgentCommissionsOutput.mutate({
                    entries: [{ id: data.id, optimisticLockVersion: data.optimisticLockVersion }],
                  })
                }
              >
                {t("commissions.batch.helpers.markAsPaid")}
              </Button>
            </ComponentWithPermission>
          )}
        </Flex>
      }
    >
      <div>
        <StrikeDiagonal lineLengthPercentage={90} lineColor={cssVariables.colorRed}>
          <AntIcon type="euro-circle" color="red" />
        </StrikeDiagonal>
      </div>
    </Popover>
  );
};
